import { useMutation as useCoreMutation } from './promiseState'

import { UseMutationConfig, useResolvedPromise } from './useResolvedPromise'

/**
 * Wraps the base `useMutation` from `~/shared/hooks/promiseState` with Lucian-specific
 * side effects via useResolvedPromise. This includes some code duplication
 * to get the types to match the base hook.
 */
export function useMutation<P extends unknown[], S, E = unknown>(
  getPromise: (...args: P) => Promise<S>,
  config: UseMutationConfig = { initialLoading: false },
) {
  const mutation = useCoreMutation<P, S, E>(getPromise, config)
  useResolvedPromise(mutation, config)
  return mutation
}
